import React from 'react';
import PropTypes from 'prop-types';
import Review from './review';

const ReviewVisualizer = ({ data }) => {
  if (data[0].reviews.length < 1) {
    return 'Keine Bewertungen im ausgewählten Zeitraum';
  }

  // eslint-disable-next-line no-underscore-dangle
  const reviews = data[0].reviews.map(review => <Review key={review._id} {...review} />);

  return (
    <div>
      {reviews}
    </div>
  );
};

ReviewVisualizer.propTypes = {
  data: PropTypes.array.isRequired,
};

export default ReviewVisualizer;
